import { render, staticRenderFns } from "./NewFilters.vue?vue&type=template&id=e52477b6&scoped=true"
import script from "./NewFilters.vue?vue&type=script&lang=js"
export * from "./NewFilters.vue?vue&type=script&lang=js"
import style0 from "./NewFilters.vue?vue&type=style&index=0&id=e52477b6&prod&lang=css"
import style1 from "./NewFilters.vue?vue&type=style&index=1&id=e52477b6&prod&lang=scss&scoped=true"
import style2 from "./NewFilters.vue?vue&type=style&index=2&id=e52477b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52477b6",
  null
  
)

export default component.exports